/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { NotificationsAodDeficiencyBreachedNotificationDataDto } from "./NotificationsAodDeficiencyBreachedNotificationDataDto";

export const NotificationsAodDeficiencyBreachedNotificationDtoWorkflowKeyEnum = {
    "audit-reports_aod-deficiency-breached": "audit-reports_aod-deficiency-breached"
} as const;

export type NotificationsAodDeficiencyBreachedNotificationDtoWorkflowKeyEnumKey = (typeof NotificationsAodDeficiencyBreachedNotificationDtoWorkflowKeyEnum)[keyof typeof NotificationsAodDeficiencyBreachedNotificationDtoWorkflowKeyEnum];

export type NotificationsAodDeficiencyBreachedNotificationDto = {
    /**
     * @description Knock workflow key. Map from the feed item source.key; not part of trigger data.
     * @type string
    */
    workflowKey: NotificationsAodDeficiencyBreachedNotificationDtoWorkflowKeyEnumKey;
    /**
     * @description In-app notification data for audit-reports_aod-deficiency-breached
     * @type object
    */
    data: NotificationsAodDeficiencyBreachedNotificationDataDto;
};